export const InstrumentOwnerType = {
  Company: "company",
  Worker: "worker",
  Zeal: "zeal",
} as const;
export type InstrumentOwnerType =
  (typeof InstrumentOwnerType)[keyof typeof InstrumentOwnerType];
